// Puesta a punto (autogestión 2026-10-30 §2.1, T-cdqn) — el contrato de
// GET /organizations/me/setup-status que consume Administración · Resumen.
//
// Cada fila de la lista es una clave estable, un `ok` y un `summary` en
// es-CL armado en el servidor con los sustantivos de la receta («12
// tiendas en 4 zonas», «3 de 12 tiendas sin checklist asignado»). El
// título de la fila y la sección a la que navega los pone el dashboard
// por clave; el cliente nunca recalcula el estado.
//
// Sólo las filas que core-api puede responder con sus propias tablas:
// «Equipo invitado» vive en auth-svc (la pantalla lo arma con el roster)
// y «Contexto de la IA» todavía no existe en esta rama. Ambas se suman
// acá como claves nuevas cuando tengan backend; el dashboard tolera que
// una clave falte.
import { z } from "zod";
export const setupStatusKeySchema = z.enum(["datos_logo", "activos", "checklists"]);
export const setupStatusItemSchema = z.object({
    key: setupStatusKeySchema,
    ok: z.boolean(),
    // Resumen numérico en es-CL, listo para mostrar como subtítulo.
    summary: z.string().min(1),
});
// GET /organizations/me/setup-status
export const setupStatusResponseSchema = z.object({
    items: z.array(setupStatusItemSchema),
});
//# sourceMappingURL=setup-status.js.map